import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-creditList',
  templateUrl: './creditlist.component.html'
})
export class CreditListComponent {
 
  columnName: string = 'validFrom';
  columns: string[] = ['validFrom', 'type', 'amount', 'remaining', 'validUntil', 'status'];
  currentPage: number = 1;
  descending: boolean = true;
  filterCredits = { count: -1 };
  filteredCredits: any[] = [];
  itemsPerPage: number = 10;
  orderBy: string = 'desc';
  pageSize!: number;
  @Input() credits!: any[];
  @Input() organisation!: any;
  @Input() filter: string = <string>{};
  @Input() NotAllowedToAddOrDeleteCredits: boolean = true;
  @Output() deleteCreditBundle: EventEmitter<string> = new EventEmitter<string>();

  onPageChanged(pageNum: any): void {
    this.pageSize = this.itemsPerPage*(pageNum - 1);
  }

  changePagesize(num:number): void {
    this.itemsPerPage = num;
  }

  sortData(column: string) {
    if (this.columnName == column) {
      this.descending = !this.descending;
    } else {
      this.columnName = column;
      this.descending = false;
    }
    if (!this.descending) {
      this.orderBy = 'asc';
    } else {
      this.orderBy = 'desc';
    }
  }

  delete(event: any) {
    this.deleteCreditBundle.emit(event);
  }

}
